import { render, staticRenderFns } from "./UnderWarrantyModel.vue?vue&type=template&id=7a64200e&"
import script from "./UnderWarrantyModel.vue?vue&type=script&lang=js&"
export * from "./UnderWarrantyModel.vue?vue&type=script&lang=js&"
import style0 from "./UnderWarrantyModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports